/***************************************************************************/
"use client";
/***************************************************************************/

import { Button } from "@/client/components/ui/button";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type TResendTimerProps = {
  onResendOTP: () => Promise<void>;
  initialTime: number;
  resendLoading: boolean;
};

const ResendTimer: React.FC<TResendTimerProps> = ({
  onResendOTP,
  initialTime,
  resendLoading,
}) => {
  const { t: tAuth } = useTranslation("auth");
  const { t: tR } = useTranslation("r");
  const [timer, setTimer] = useState<number>(initialTime);

  useEffect(() => {
    let timerInterval: NodeJS.Timeout;
    if (timer > 0) {
      timerInterval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timerInterval);
  }, [timer]);

  const handleResendClick = async () => {
    await onResendOTP();
    setTimer(initialTime);
  };

  return (
    <div className="flex flex-row items-center">
      {tAuth("otp.otpNotReceived")}
      {timer === 0 ? (
        <Button
          type="button"
          variant="link"
          size="lg"
          onClick={handleResendClick}
          disabled={resendLoading}
          loading={resendLoading}
        >
          <span>{tR("resend")}</span>
        </Button>
      ) : (
        <span className="ml-2 text-sm text-gray-500">
          {tAuth("otp.resendTimer")} {timer}s
        </span>
      )}
    </div>
  );
};

export default ResendTimer;
